import { useGetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab } from '@/shared/api/generated';

import type { EnrollmentFinancialSummary } from '../types/enrollment';

/**
 * Hook para carregar os dados financeiros de uma matrícula a partir da aba financeira.
 *
 * @param enrollmentId - ID da matrícula
 * @returns Resumo financeiro mapeado, estado de loading e erro
 */
export function useEnrollmentFinancial(enrollmentId: number) {
  const { data, isLoading, isError } =
    useGetApiV1CourseregistrationEnrollmentCourseregistrationidFinancialTab(enrollmentId);

  const financialSummary: EnrollmentFinancialSummary | null = data
    ? {
        totalValue: data.planTotalValue ?? 0,
        paidValue: 0,
        remainingValue: data.planTotalValue ?? 0,
        nextDueDate: data.registrationTaxExpirationDate ?? data.firstTuitionExpirationDate ?? null,
        nextDueValue: null,
        totalInstallments: data.numberParcels ?? 0,
        paidInstallments: 0,
        remainingInstallments: data.numberParcels ?? 0,
        hasEnrollmentFee: !!data.registrationTaxExpirationDate,
        registrationTaxExpirationDate: data.registrationTaxExpirationDate ?? null,
        poloCanChangeRegistrationTax: data.poloCanChangeRegistrationTax ?? false,
        firstTuitionExpirationDate: data.firstTuitionExpirationDate ?? null,
        poloCanChangeFirstTuition: data.poloCanChangeFirstTuition ?? false,
        isPoloAllowedToChangeFinancial: data.isPoloAllowedToChangeFinancial ?? false,
        descriptionPaymentMethod: data.descriptionPaymentMethod ?? null,
        paymentInCashOrInstallments: data.paymentInCashOrInstallments ?? null,
        isScholarshipHolder: data.isScholarshipHolder ?? false,
        planSummary: data.planSummary ?? null,
        discounts: (data.discounts ?? []).map(d => ({
          discountTypeText: d.discountTypeText ?? null,
          percentage: d.percentage ?? null,
          description: d.description ?? null,
          companyName: d.companyName ?? null,
        })),
      }
    : null;

  return { financialSummary, isLoading, isError } as const;
}
